export const getSelectedSubjectName = (key) => {
    const subjectNames = {
        ko: { name: "국어" },
        ko_1: { name: "화법과작문" },
        ko_2: { name: "언어와매체" },

        math: { name: "수학" },
        math_1: { name: "확률과통계" },
        math_2: { name: "미적분" },
        math_3: { name: "기하" },

        en: { name: "영어" },

        history: { name: "한국사" },

        explore: { name: "사회/과학탐구" },
        social_1: { name: "생활과윤리" },
        social_2: { name: "윤리와사상" },
        social_3: { name: "한국지리" },
        social_4: { name: "세계지리" },
        social_5: { name: "동아시아사" },
        social_6: { name: "세계사" },
        social_7: { name: "경제" },
        social_8: { name: "정치와 법" },
        social_9: { name: "사회·문화" },

        science_1: { name: "물리학1" },
        science_2: { name: "화학1" },
        science_3: { name: "생명과학1" },
        science_4: { name: "지구과학1" },
        science_5: { name: "물리학2" },
        science_6: { name: "화학2" },
        science_7: { name: "생명과학2" },
        science_8: { name: "지구과학2" },
    }

    if (key) {
        return subjectNames[key] ? subjectNames[key]['name'] : ''
    } else {
        return ''
    }
}



const academicRecordDefaultValue = {
    cambridge: {
        second_lang: '',
        eng: '',
        math: {
            igc: '',
            as: ''
        },
        science: {
            biology: {
                igc: '',
                as: ''
            },
            chemistry: {
                igc: '',
                as: ''
            },
            physics: {
                igc: '',
                as: ''
            },
        },
        social: {
            global: '',
            history: {
                igc: '',
                as: ''
            },
            business: {
                igc: '',
                as: ''
            },
            economics: {
                igc: '',
                as: ''
            },
        }
    },
    korean: {
        korean: '',
        literature: '',
        speech: '',
        lang_media: '',
        reading: '',
        high_math: '',
        math1: '',
        math2: '',
        calculus: '',
        probability: ''
    },
    eng_reading_1: '',
    eng_reading_2: '',
    academic_reading: '',
    vietnamese: '',
    pe: '',
    club: '',
    electives: ['', '', '', '', '', '', '', '']
}

const attendanceDefaultValue = {
    schooldays: '',
    attendance: '',
    absebce: {
        sick: '',
        unexcued: '',
        other: ''
    },
    tardiness: {
        sick: '',
        unexcued: '',
        other: ''
    },
    early: {
        sick: '',
        unexcued: '',
        other: ''
    },
    remark: ''
}
export const schoolRecord_ver2_default_value = {

    // 1. Student Information
    studentInfo: {
        name: '', nationality: '', birth: '', gender: '', entrance: '', passport: '',
    },

    // 2. Academic Record
    academicRecord: {
        enrollment: {
            from: '',
            to: '',
        },
        records: {
            g10: {
                first: academicRecordDefaultValue,
                second: academicRecordDefaultValue
            },
            g11: {
                first: academicRecordDefaultValue,
                second: academicRecordDefaultValue
            },
            g12: {
                first: academicRecordDefaultValue,
                second: academicRecordDefaultValue
            },
            electives: [
                '', '', '', '',
                '', '', '', ''
            ],
        },
    },

    // 3. Teacher’s comments on subjects 
    teacherComments: {
        grade10: {
            semester1: [
                { subject: '', teacher: '', comment: '' }
            ],
            semester2: [
                { subject: '', teacher: '', comment: '' }
            ]
        },
        grade11: {
            semester1: [
                { subject: '', teacher: '', comment: '' }
            ],
            semester2: [
                { subject: '', teacher: '', comment: '' }
            ]
        },
        grade12: {
            semester1: [
                { subject: '', teacher: '', comment: '' }
            ],
            semester2: [
                { subject: '', teacher: '', comment: '' }
            ]
        }
    },

    // 4. Educational Background 
    educationalBackground: {
        entrance: '',
        graduated: ''
    },

    // 5. Attendance Record 
    attendance: {
        grade10: {
            semester1: attendanceDefaultValue,
            semester2: attendanceDefaultValue
        },
        grade11: {
            semester1: attendanceDefaultValue,
            semester2: attendanceDefaultValue
        },
        grade12: {
            semester1: attendanceDefaultValue,
            semester2: attendanceDefaultValue
        }
    },

    // 6. Awards & Certificate of Appointment 
    awards: {
        inSchool: [
            { title: '', level: '', date: '', presenter: '' }
        ],
        outSchool: [
            { title: '', level: '', date: '', presenter: '' }
        ],
        certificate: [
            { title: '', level: '', date: '', presenter: '' }
        ]
    },

    // 7. Extracurricular Activities
    extracurricular: {
        g10: {
            first: [{ date: '', place: '', detail: '', hour: '' }],
            second: [{ date: '', place: '', detail: '', hour: '' }]
        },
        g11: {
            first: [{ date: '', place: '', detail: '', hour: '' }],
            second: [{ date: '', place: '', detail: '', hour: '' }]
        },
        g12: {
            first: [{ date: '', place: '', detail: '', hour: '' }],
            second: [{ date: '', place: '', detail: '', hour: '' }]
        },
    },

    // 8. Exploratory Activities
    exploratory: [
        { grade: '', title: '' }
    ],

    // 9. Volunteer work
    volunteer: {
        g10: {
            first: [{ date: '', place: '', detail: '', hour: '' }],
            second: [{ date: '', place: '', detail: '', hour: '' }]
        },
        g11: {
            first: [{ date: '', place: '', detail: '', hour: '' }],
            second: [{ date: '', place: '', detail: '', hour: '' }]
        },
        g12: {
            first: [{ date: '', place: '', detail: '', hour: '' }],
            second: [{ date: '', place: '', detail: '', hour: '' }]
        },
    },

    // 10. Behavioral Remark
    behavioral: {
        g10: {
            comment: '', teacher: ''
        },
        g11: {
            comment: '', teacher: ''
        },
        g12: {
            comment: '', teacher: ''
        },
    }
}

